import { render, staticRenderFns } from "./HelpdeskStoryCard.vue?vue&type=template&id=f3887a38&scoped=true"
import script from "./HelpdeskStoryCard.vue?vue&type=script&lang=ts"
export * from "./HelpdeskStoryCard.vue?vue&type=script&lang=ts"
import style0 from "./HelpdeskStoryCard.vue?vue&type=style&index=0&id=f3887a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3887a38",
  null
  
)

export default component.exports